export enum TypeJob {
  REMINDER_SERVICE = "CULTO LEMBRETE",
  CAMPAIGN_REMINDER_PAYMENT = "CAMPANHA LEMBRETE PAGAMENTO",
  CETADEL_REMINDER_PAYMENT = "CETADEL LEMBRETE PAGAMENTO",
  EVENT_REMINDER_PAYMENT = "EVENTO LEMBRETE PAGAMENTO"
}